import { ContractSearchDto, ParcelSearchItem, SubjectContactResponseDto } from '../../api/backend'

export interface Command {
    id: string;
    title: string;
    category: CommandCategory;
    keywords?: Array<string>;
    icon?: string;
    subtitle?: string;
    action: () => void;
    // Entity payload pro bohaté vykreslení výsledku vyhledávání (osoba/smlouva/parcela).
    // Vyplněno jen u položek z agregovaného search endpointu; ostatní příkazy (Vytvořit,
    // Admin, …) je nechávají prázdné a vykreslují se generickým title/subtitle.
    subject?: SubjectContactResponseDto;
    contract?: ContractSearchDto;
    parcel?: ParcelSearchItem;
    // Syntetické akční řádky na konci entitní sekce (DEV-1295). Nejsou to výsledky, ale zůstávají
    // ve flatResults, aby byly dosažitelné šipkami stejně jako všechno ostatní:
    //   'expander' – rozbalí sekci na místě, paletu nechává otevřenou a neloguje se do most-visited,
    //   'showAll'  – proklik do seznamu entity s předvyplněným hledáním (zavře paletu jako běžný příkaz).
    rowKind?: CommandRowKind;
}

export type CommandRowKind = 'expander' | 'showAll'

export enum CommandCategory {
    MostVisited = 'mostVisited',
    Create = 'create',
    Subjects = 'subjects',
    Contracts = 'contracts',
    Parcels = 'parcels',
    Admin = 'admin'
}

export const CATEGORY_LABELS: Record<CommandCategory, string> = {
    [CommandCategory.MostVisited]: 'Nejčastější',
    [CommandCategory.Create]: 'Vytvořit',
    [CommandCategory.Subjects]: 'Osoby',
    [CommandCategory.Contracts]: 'Smlouvy',
    [CommandCategory.Parcels]: 'Parcely',
    [CommandCategory.Admin]: 'Administrace'
}

// Cíl prokliku „Zobrazit všech N…" pro entitní sekce. Formulováno tak, aby to v šabloně
// navazovalo na předložku „v" (v seznamu osob).
export const CATEGORY_LIST_TARGETS: Partial<Record<CommandCategory, string>> = {
    [CommandCategory.Subjects]: 'seznamu osob',
    [CommandCategory.Contracts]: 'seznamu smluv',
    [CommandCategory.Parcels]: 'seznamu parcel'
}

// Pořadí sekcí v paletě.
// Bez query: MostVisited → Create → Admin
// S query: Create (match) → Subjects → Contracts → Parcels → Admin (match)
// Subjects/Contracts/Parcels se aktivují až s query ≥ 2 znaky.
export const CATEGORY_ORDER: Array<CommandCategory> = [
    CommandCategory.MostVisited,
    CommandCategory.Create,
    CommandCategory.Subjects,
    CommandCategory.Contracts,
    CommandCategory.Parcels,
    CommandCategory.Admin
]